import { createStore, createEvent } from 'effector';

export const $pushNotifications = createStore([]);

export const setPushNotification = createEvent();

$pushNotifications
    .on(setPushNotification, (_, value) => value);